import {
  SPIDER_ARC_END_RAD,
  SPIDER_ARC_START_RAD,
  SPIDER_DEFAULT_RADIUS_METERS,
} from './markerSpider.constants';

export type SpiderFanOffsetMeters = {
  northMeters: number;
  eastMeters: number;
};

export function computeSpiderFanOffsetsMeters(
  count: number
): SpiderFanOffsetMeters[] {
  if (count <= 0) {
    return [];
  }
  const offsets: SpiderFanOffsetMeters[] = [];
  for (let fanOffsetIndex = 0; fanOffsetIndex < count; fanOffsetIndex += 1) {
    const ratioAlongArc =
      count === 1 ? 0.5 : fanOffsetIndex / (count - 1);
    const alpha =
      SPIDER_ARC_START_RAD +
      ratioAlongArc * (SPIDER_ARC_END_RAD - SPIDER_ARC_START_RAD);
    const northMeters = SPIDER_DEFAULT_RADIUS_METERS * Math.sin(alpha);
    const eastMeters = SPIDER_DEFAULT_RADIUS_METERS * Math.cos(alpha);
    offsets.push({ northMeters, eastMeters });
  }
  return offsets;
}
